(() => {
  const punctuation = /[，。]|,(?!\d{3}(?:\D|$))|(?<!\d)\.(?!\d)/g;
  const words = /口含錠|發泡錠|維生素|維他命|蔓越莓|葉黃素|鮭魚油|濃縮精華|電解質|精胺酸|精氨酸|生物類黃酮|葡萄柚|水蜜桃|[CＣ]\s*\d+(?:\.\d+)?\s*(?:mg|毫克)?|Omega[-‑]3|B\s*群|B6|PACs|600:1/gi;
  const normalize = (scope) => {
    scope.querySelectorAll('h1,h2,h3,h4,h5,h6,.fizz-range-copy strong,.global-proof-statement').forEach(heading => {
      if (heading.dataset.slTypeset === 'true' || heading.closest('#PBarNextFrame, [data-shopify-editor]')) return;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (node.parentElement?.closest('svg,script,style,.sl-word,[aria-hidden="true"]')) return;
        const text = node.textContent.replace(punctuation, ' ').replace(/ {2,}/g, ' ');
        const fragment = document.createDocumentFragment();
        let last = 0;
        for (const match of text.matchAll(words)) {
          fragment.append(document.createTextNode(text.slice(last, match.index)));
          const word = document.createElement('span');
          word.className = 'sl-word';
          word.textContent = match[0];
          fragment.append(word);
          last = match.index + match[0].length;
        }
        fragment.append(document.createTextNode(text.slice(last)));
        node.replaceWith(fragment);
      });
      heading.classList.add('sl-heading-clean');
      heading.dataset.slTypeset = 'true';
    });
  };
  normalize(document);
  document.addEventListener('shopify:section:load', event => normalize(event.target));
})();


(() => {
 const mobile = window.matchMedia('(max-width:760px)');
 document.querySelectorAll('.sl-proof-disclosure').forEach(detail => { detail.open = !mobile.matches; });
})();
